import { useEffect, useMemo, useState, type ReactNode } from "react";
import {
  getActiveOfficeLogo,
  type ActiveOfficeLogo,
} from "../../lib/office-branding";
import { defaultOfficeBrandingSettings } from "../../lib/office-branding";

type OfficeLogoImageProps = {
  alt?: (string) | undefined;
  className?: (string) | undefined;
  decorative?: (boolean) | undefined;
  fallback?: (ReactNode) | undefined;
  logo?: (ActiveOfficeLogo) | undefined;
  onFallback?: (() => void) | undefined;
};

export function OfficeLogoImage({
  alt,
  className,
  decorative = false,
  fallback = null,
  logo,
  onFallback,
}: OfficeLogoImageProps) {
  const storedBranding = defaultOfficeBrandingSettings;
  const storedLogo = useMemo(() => getActiveOfficeLogo(storedBranding), [storedBranding]);
  const activeLogo = logo ?? storedLogo;
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [activeLogo.src]);

  function handleImageError() {
    setHasError(true);
    onFallback?.();
  }

  if (hasError) {
    return fallback;
  }

  return (
    <img
      alt={decorative ? "" : alt ?? activeLogo.alt}
      aria-hidden={decorative ? true : undefined}
      className={className}
      draggable={false}
      src={activeLogo.src}
      onError={handleImageError}
    />
  );
}
